import React, { useState } from "react";
import HeaderWithNav from "../Header/HeaderWithNav";
import Asidebar from "../Header/Asidebar";
import { Link } from "react-router-dom";
import { merge } from "jquery";

const QuotaView = () => {
  const [isActivated, setIsActivated] = useState(true);
  const [fullwidthwrapper, setFullwidthwrapper] = useState("");
  const [isPlaying, setIsPlaying] = useState(false);
  // const [inputValue1, setInputValue1] = useState("");
  // const [inputValue2, setInputValue2] = useState("");
  const [isEditable1, setIsEditable1] = useState(false); // Edit mode for input 1
  const [isEditable2, setIsEditable2] = useState(false); // Edit mode for input 2
  const [isMerged, setIsMerged] = useState(false); // State for merged input
  // const [isMerged, setIsMerged] = useState({
  //   input1: false,
  //   input2: false,
  //   // Add more input keys as needed
  // });
  const [inputValues, setInputValues] = useState([
    { inputValue1: "", inputValue2: "" }, // First td (index 0)
    { inputValue1: "", inputValue2: "" }, // Second td (index 1)
    { inputValue1: "", inputValue2: "" }, //third td (index 2)
    { inputValue1: "", inputValue2: "" }, //third td (index 3)
    { inputValue1: "", inputValue2: "" }, //third td (index 4)
    { inputValue1: "", inputValue2: "" }, //third td (index 5)
    { inputValue1: "", inputValue2: "" }, //third td (index 6)
    { inputValue1: "", inputValue2: "" }, //third td (index 7)
  ]);
  const handleInputChange = (index, field, value) => {
    const updatedValues = [...inputValues];
    updatedValues[index][field] = value;
    setInputValues(updatedValues);
  };
  // const handleDoubleClick = () => {
  //   setIsMerged(!isMerged); // Toggle merge state
  // };
  const handleDoubleClick = (inputId) => {
    setIsMerged((prevIsMerged) => ({
      ...prevIsMerged,
      [inputId]: !prevIsMerged[inputId], // Toggle the merge state for the given input
    }));
  };

  const handleBlur = () => {
    setIsEditable1(false);
    setIsEditable2(false);
  };

  const handleChange = (event, setValue) => {
    setValue(event.target.value); // Update input value
  };

  const handleClick = (buttonId) => {
    setIsPlaying((prevIsPlaying) => {
      return { ...prevIsPlaying, [buttonId]: !prevIsPlaying[buttonId] };
    });
  };


  const handleToggle = () => {
    setIsActivated(!isActivated);
    setFullwidthwrapper(isActivated ? "fullwrapper" : "");
  };

  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullwidthwrapper}>
        <HeaderWithNav onclick={handleToggle} />

        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-lg-12">
              <div className="card border-light-subtle">
                <div className="d-flex justify-content-between align-items-center p-2">
                  <div className="ms-2 mt-2 ">
                    <label htmlFor="quotaName" className="form-label">
                      Quota Name
                    </label>
                  </div>

                  <div className="d-flex align-items-center ms-6 mt-1">
                    <div className="d-flex align-items-center mr-4">
                      <i class="bi bi-circle-fill text-danger"></i>
                      <span className="ms-2">Required</span>
                    </div>
                    <div className="d-flex align-items-center ms-4">
                      <i class="bi bi-circle-fill text-success"></i>
                      <span className="ms-2">Achieved</span>
                    </div>
                  </div>

                  <div className="d-flex align-items-center">
                    <Link to="/add-quota">
                      <button className="btn btn-success">Add Quota</button>
                    </Link>
                    <Link to="/edit-quota">
                      <button className="btn ">
                        <i className="bi bi-pencil-square"></i>
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Table Content */}
          <div className="card p-1 border-light-subtle mt-3">
            <div className="table-responsive ">
              <table className="table table-bordered lh-10">
                <thead className="thead-custom ">
                  <tr
                    style={{
                      borderTop: "none",
                    }}
                  >
                    <th colSpan="3" className="first-th  text-muted">
                      Quota Type: Hit
                    </th>
                    <th className="col-md-2 text-center text-muted ">MSCI</th>
                    <th className="col-md-2 text-center text-muted">CDP</th>
                    <th className="col-md-1 text-center bordered-th text-muted">
                      Bloomberg
                    </th>
                    <th className="col-md-3 text-center border:0 last-th text-muted">
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td rowSpan="4" className="mt-2 align-middle first-th">
                      <abbr title="Australia or China or Finland">
                        Australia{" "}
                        <span style={{ color: "#6495ED", fontWeight: "bold" }}>
                          or
                        </span>{" "}
                        China{" "}
                        <span style={{ color: "#6495ED", fontWeight: "bold" }}>
                          or
                        </span>{" "}
                        Finland
                      </abbr>
                    </td>

                    {/* <td rowSpan="2" className="align-middle">
                      1 to 250 employees or 251 to 500 employees
                    </td> */}
                    <td rowSpan="2" className="align-middle">
                      <abbr title="1 to 250 employees or 251 to 500 employees">
                        1 to 250 employees{" "}
                        <span style={{ color: "#6495ED", fontWeight: "bold" }}>
                          or
                        </span>{" "}
                        251 to 500 employees
                      </abbr>
                    </td>

                    {/* <td>
                      Ceo/Managing Director{" "}
                      <span style={{ color: "#6495ED", fontWeight: "bold" }}>
                        or
                      </span>{" "}
                      Director
                      <abbr title="Ceo/Managing Director or Director"></abbr>
                    </td> */}
                    <td>
                      <abbr title="Ceo/Managing Director or Director">
                        Ceo/Managing Director{" "}
                        <span style={{ color: "#6495ED", fontWeight: "bold" }}>
                          or
                        </span>{" "}
                        Director
                      </abbr>
                    </td>

                    <td className="py-6 align-bottom" rowSpan="1">
                      <div class="d-flex align-items-center">
                        <abbr title="fre">
                          <input
                            type="number"
                            className="form-control d-inline-block ms-2 mb-2 text-center input-achieved"
                            style={{
                              cursor: isEditable1 ? "text" : "pointer",
                              width: "55px",
                              borderColor: "green",
                              borderWidth: "1px",
                              borderStyle: "solid",
                            }}
                          />
                        </abbr>
                        <div class="input-container">
                          <input
                            type="number"
                            className="form-control d-inline-block ms-2 mb-2 text-center input-achieved"
                            style={{
                              cursor: isEditable2 ? "text" : "pointer",
                              width: "55px",
                              borderColor: "green",
                              borderWidth: "1px",
                              borderStyle: "solid",
                            }}
                          />

                          <span class="tooltip">Achieved</span>
                        </div>

                        <button className="tick ms-2 ">
                          <i class="bi bi-check-circle-fill "></i>
                        </button>
                      </div>
                    </td>

                    {/* <td className="py-6 align-bottom" rowSpan="2">
                      <div className="input-container">
                        <input
                          type="number"
                          className="form-control d-inline-block mb-2 ms-3 text-center input-required"
                          style={{
                            width: "58px",
                            borderColor: "red",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                        <span className="tooltip">Required</span>
                      </div>
                      <div className="input-container">
                        <input
                          type="number"
                          className="form-control d-inline-block ms-2 text-center input-achieved"
                          style={{
                            width: "58px",
                            borderColor: "green",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                        <span className="tooltip">Achieved</span>
                      </div>
                    </td> */}
                    <td className="py-6 align-bottom" rowSpan="1">
                      <div className="d-flex align-items-center">
                        {isMerged.merge1 ? (
                          <div
                            className="input-container merged"
                            onDoubleClick={() => handleDoubleClick("merge1")}
                          >
                            <input
                              type="number"
                              className="form-control text-center input-merged ms-4"
                              value={inputValues[0].inputValue1} // First td input
                              onBlur={handleBlur}
                              onChange={(event) => {
                                const [val1, val2] =
                                  event.target.value.split(" ");
                                handleInputChange(0, "inputValue1", val1 || ""); // First td
                                handleInputChange(0, "inputValue2", val2 || ""); // First td
                              }}
                              style={{
                                width: "110px",
                                borderColor: "black",
                                borderWidth: "1px",
                                borderStyle: "solid",
                              }}
                            />
                          </div>
                        ) : (
                          <>
                            <div
                              className="input-container"
                              onDoubleClick={() => handleDoubleClick("merge1")}
                            >
                              <input
                                type="number"
                                className="form-control d-inline-block ms-2 mb-2 text-center input-required"
                                value={inputValues[0].inputValue1} // First td input
                                readOnly={!isEditable1}
                                onBlur={handleBlur}
                                onChange={
                                  (event) =>
                                    handleInputChange(
                                      0,
                                      "inputValue1",
                                      event.target.value
                                    ) // First td
                                }
                                style={{
                                  cursor: isEditable1 ? "text" : "pointer",
                                  width: "55px",
                                  borderColor: "red",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                disabled={isPlaying.button7}
                              />
                              <span className="tooltip">Required</span>
                            </div>
                            <div
                              className="input-container"
                            // onDoubleClick={() => handleDoubleClick("merge1")}
                            >
                              <input
                                type="number"
                                className="form-control d-inline-block ms-2 mb-2 text-center input-achieved"
                                value={inputValues[0].inputValue2} // First td input
                                readOnly={!isEditable2}
                                onBlur={handleBlur}
                                onChange={
                                  (event) =>
                                    handleInputChange(
                                      0,
                                      "inputValue2",
                                      event.target.value
                                    ) // First td
                                }
                                style={{
                                  cursor: isEditable2 ? "text" : "pointer",
                                  width: "55px",
                                  borderColor: "green",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                disabled={isPlaying.button7}
                              />
                              <span className="tooltip">Achieved</span>
                            </div>
                            <button
                              className="btn p-0 d-flex align-items-center justify-content-center ms-1"
                              style={{
                                width: "2rem",
                                height: "2rem",
                                borderRadius: "50%",
                                backgroundColor: "white",
                              }}
                              onClick={() => handleClick("button7")}
                            >
                              {/* Conditionally render icons based on state */}
                              {isPlaying.button7 ? (
                                <i
                                  className="bi bi-pause-circle-fill"
                                  style={{
                                    fontSize: "1.3rem",
                                    color: "black",
                                  }}
                                ></i>
                              ) : (
                                <i
                                  className="bi bi-play-circle-fill"
                                  style={{
                                    fontSize: "1.3rem",
                                    color: "black",
                                  }}
                                ></i>
                              )}
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                    {/* <td className="py-6 align-bottom" rowSpan="1">
                      <div class="d-flex align-items-center">
                        <div class="input-container">
                          <input
                            type="number"
                            class="form-control d-inline-block mb-2 ms-3 text-center input-required"
                            style={{
                              width: "55px",
                              borderColor: "red",
                              borderWidth: "1px",
                              borderStyle: "solid",
                            }}
                            disabled={isPlaying.button8}
                          />
                          <span class="tooltip">Required</span>
                        </div>
                        <div class="input-container">
                          <input
                            type="number"
                            class="form-control d-inline-block ms-1 mb-2 text-center input-achieved"
                            style={{
                              width: "57px",
                              borderColor: "green",
                              borderWidth: "1px",
                              borderStyle: "solid",
                            }}
                            disabled={isPlaying.button8}
                          />
                          <span class="tooltip">Achieved</span>
                        </div>

                        <button
                          className="btn p-0 d-flex align-items-center justify-content-center ms-1"
                          style={{
                            width: "2rem",
                            height: "2rem",
                            borderRadius: "50%",
                            backgroundColor: "white",
                          }}
                          onClick={() => handleClick("button8")}
                        >
                          {isPlaying.button8 ? (
                            <i
                              className="bi bi-pause-circle-fill"
                              style={{
                                fontSize: "1.3rem",
                                color: "black",
                              }}
                            ></i>
                          ) : (
                            <i
                              className="bi bi-play-circle-fill"
                              style={{
                                fontSize: "1.3rem",
                                color: "black",
                              }}
                            ></i>
                          )}
                        </button>
                      </div>
                    </td> */}

                    <td className="py-6 align-bottom" rowSpan="1">
                      <div className="d-flex align-items-center">
                        {isMerged.merge2 ? (
                          <div
                            className="input-container merged"
                            onDoubleClick={() => handleDoubleClick("merge2")}
                          >
                            <input
                              type="number"
                              className="form-control text-center input-merged ms-4"
                              value={inputValues[1].inputValue1} // Second td input
                              onBlur={handleBlur}
                              onChange={(event) => {
                                const [val1, val2] =
                                  event.target.value.split(" ");
                                handleInputChange(1, "inputValue1", val1 || ""); // Second td
                                handleInputChange(1, "inputValue2", val2 || ""); // Second td
                              }}
                              style={{
                                width: "110px",
                                borderColor: "black",
                                borderWidth: "1px",
                                borderStyle: "solid",
                              }}
                            />
                          </div>
                        ) : (
                          <>
                            <div
                              className="input-container"
                              onDoubleClick={() => handleDoubleClick("merge2")}
                            >
                              <input
                                type="number"
                                className="form-control d-inline-block ms-2 mb-2 text-center input-required"
                                value={inputValues[1].inputValue1} // Second td input
                                readOnly={!isEditable1}
                                onBlur={handleBlur}
                                onChange={
                                  (event) =>
                                    handleInputChange(
                                      1,
                                      "inputValue1",
                                      event.target.value
                                    ) // Second td
                                }
                                style={{
                                  cursor: isEditable1 ? "text" : "pointer",
                                  width: "55px",
                                  borderColor: "red",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                disabled={isPlaying.button8}
                              />
                              <span className="tooltip">Required</span>
                            </div>
                            <div
                              className="input-container"
                            // onDoubleClick={() => handleDoubleClick("merge2")}
                            >
                              <input
                                type="number"
                                className="form-control d-inline-block ms-2 mb-2 text-center input-achieved"
                                value={inputValues[1].inputValue2} // Second td input
                                readOnly={!isEditable2}
                                onBlur={handleBlur}
                                onChange={
                                  (event) =>
                                    handleInputChange(
                                      1,
                                      "inputValue2",
                                      event.target.value
                                    ) // Second td
                                }
                                style={{
                                  cursor: isEditable2 ? "text" : "pointer",
                                  width: "55px",
                                  borderColor: "green",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                disabled={isPlaying.button8}
                              />
                              <span className="tooltip">Achieved</span>
                            </div>
                            <button
                              className="btn p-0 d-flex align-items-center justify-content-center ms-1"
                              style={{
                                width: "2rem",
                                height: "2rem",
                                borderRadius: "50%",
                                backgroundColor: "white",
                              }}
                              onClick={() => handleClick("button8")}
                            >
                              {/* Conditionally render icons based on state */}
                              {isPlaying.button8 ? (
                                <i
                                  className="bi bi-pause-circle-fill"
                                  style={{
                                    fontSize: "1.3rem",
                                    color: "black",
                                  }}
                                ></i>
                              ) : (
                                <i
                                  className="bi bi-play-circle-fill"
                                  style={{
                                    fontSize: "1.3rem",
                                    color: "black",
                                  }}
                                ></i>
                              )}
                            </button>
                          </>
                        )}
                      </div>
                    </td>

                    <td className="py-6 align-bottom last-th" rowSpan="1">
                      <div
                        className="input-container"
                        style={{ display: "inline-block" }}
                      >
                        <input
                          type="number"
                          className="form-control d-inline-block mb-2 ms-3 text-center input-required"
                          style={{
                            width: "50px",
                            borderColor: "red",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                          readOnly
                        />
                        <span className="tooltip">Required</span>
                      </div>
                      <div
                        className="input-container"
                        style={{ display: "inline-block" }}
                      >
                        <input
                          type="number"
                          className="form-control d-inline-block ms-2 text-center input-achieved"
                          style={{
                            width: "54px",
                            borderColor: "green",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                          readOnly
                        />
                        <span className="tooltip">Achieved</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    {/* <td className="align-middle">
                      Ceo/Managing Director{" "}
                      <span style={{ color: "#6495ED", fontWeight: "bold" }}>
                        or
                      </span>{" "}
                      Director
                    </td> */}
                    <td>
                      <abbr title="Ceo/Managing Director or Director">
                        Ceo/Managing Director{" "}
                        <span style={{ color: "#6495ED", fontWeight: "bold" }}>
                          or
                        </span>{" "}
                        Director
                      </abbr>
                    </td>
                    <td
                      className="py-6 align-bottom"
                      style={{ borderTop: "2px solid white" }}
                    >
                      <div class="d-flex align-items-center">
                        <div class="input-container">
                          <input
                            type="number"
                            class="form-control d-inline-block mb-2 ms-3 text-center input-"
                            style={{
                              width: "55px",
                              borderColor: "green",
                              borderWidth: "1px",
                              borderStyle: "solid",
                            }}
                          />
                          <span class="tooltip">Achieved</span>
                        </div>
                        <div class="input-container">
                          <input
                            type="number"
                            class="form-control d-inline-block ms-2 mb-2 text-center input-achieved"
                            style={{
                              width: "55px",
                              borderColor: "green",
                              borderWidth: "1px",
                              borderStyle: "solid",
                            }}
                          />
                          <span class="tooltip">Achieved</span>
                        </div>
                        {/* <i
                          class="bi bi-check-circle ms-2"
                          style={{
                            fontSize: "1.5rem",
                            backgroundColor: "green",
                            color: "white",
                            borderRadius: "50%",
                            padding: "0.01rem",
                          }}
                        ></i> */}
                        {/* <button
                          className="btn btn-success p-0 d-flex align-items-center justify-content-center ms-1 mb-4 mt-3"
                          style={{
                            width: "1.5rem",
                            height: "1.5rem",
                            borderRadius: "50%",
                            backgroundColor: "white",
                          }}
                        >
                          <i
                            className="bi bi-check-circle "
                            style={{
                              fontSize: "1.3rem",
                              color: "white",
                            }}
                          ></i>
                        </button> */}
                        <button
                          className="tick ms-2 "
                        // style={{
                        //   background: "none", // Remove background
                        //   border: "none", // Remove border
                        //   padding: "0", // Remove padding
                        //   cursor: "pointer", // Change cursor to pointer
                        // }}
                        >
                          <i class="bi bi-check-circle-fill "></i>
                        </button>
                      </div>
                    </td>
                    <td
                      className="py-6 align-bottom"
                      rowSpan="1"
                      style={{ borderTop: "2px solid white" }}
                    >
                      <div className="d-flex align-items-center">
                        {isMerged.merge3 ? (
                          <div
                            className="input-container merged"
                            onDoubleClick={() => handleDoubleClick("merge3")}
                          >
                            <input
                              type="number"
                              className="form-control text-center input-merged ms-4"
                              value={inputValues[2].inputValue1} // First td input
                              onBlur={handleBlur}
                              onChange={(event) => {
                                const [val1, val2] =
                                  event.target.value.split(" ");
                                handleInputChange(2, "inputValue1", val1 || ""); // First td
                                handleInputChange(2, "inputValue2", val2 || ""); // First td
                              }}
                              style={{
                                width: "110px",
                                borderColor: "black",
                                borderWidth: "1px",
                                borderStyle: "solid",
                              }}
                            />
                          </div>
                        ) : (
                          <>
                            <div
                              className="input-container"
                              onDoubleClick={() => handleDoubleClick("merge3")}
                            >
                              <input
                                type="number"
                                className="form-control d-inline-block ms-2 mb-2 text-center input-required"
                                value={inputValues[2].inputValue1} // First td input
                                readOnly={!isEditable1}
                                onBlur={handleBlur}
                                onChange={
                                  (event) =>
                                    handleInputChange(
                                      2,
                                      "inputValue1",
                                      event.target.value
                                    ) // First td
                                }
                                style={{
                                  cursor: isEditable1 ? "text" : "pointer",
                                  width: "55px",
                                  borderColor: "red",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                disabled={isPlaying.button6}
                              />
                              <span className="tooltip">Required</span>
                            </div>
                            <div
                              className="input-container"
                            // onDoubleClick={() => handleDoubleClick("merge3")}
                            >
                              <input
                                type="number"
                                className="form-control d-inline-block ms-2 mb-2 text-center input-achieved"
                                value={inputValues[2].inputValue2} // First td input
                                readOnly={!isEditable2}
                                onBlur={handleBlur}
                                onChange={
                                  (event) =>
                                    handleInputChange(
                                      2,
                                      "inputValue2",
                                      event.target.value
                                    ) // First td
                                }
                                style={{
                                  cursor: isEditable2 ? "text" : "pointer",
                                  width: "55px",
                                  borderColor: "green",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                disabled={isPlaying.button6}
                              />
                              <span className="tooltip">Achieved</span>
                            </div>
                            <button
                              className="btn p-0 d-flex align-items-center justify-content-center ms-1"
                              style={{
                                width: "2rem",
                                height: "2rem",
                                borderRadius: "50%",
                                backgroundColor: "white",
                              }}
                              onClick={() => handleClick("button6")}
                            >
                              {/* Conditionally render icons based on state */}
                              {isPlaying.button6 ? (
                                <i
                                  className="bi bi-pause-circle-fill"
                                  style={{
                                    fontSize: "1.3rem",
                                    color: "black",
                                  }}
                                ></i>
                              ) : (
                                <i
                                  className="bi bi-play-circle-fill"
                                  style={{
                                    fontSize: "1.3rem",
                                    color: "black",
                                  }}
                                ></i>
                              )}
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                    <td
                      className="py-6 align-bottom"
                      rowSpan="1"
                      style={{ borderTop: "2px solid white" }}
                    >
                      <div className="d-flex align-items-center">
                        {isMerged.merge4 ? (
                          <div
                            className="input-container merged"
                            onDoubleClick={() => handleDoubleClick("merge4")}
                          >
                            <input
                              type="number"
                              className="form-control text-center input-merged ms-4"
                              value={inputValues[3].inputValue1} // First td input
                              onBlur={handleBlur}
                              onChange={(event) => {
                                const [val1, val2] =
                                  event.target.value.split(" ");
                                handleInputChange(3, "inputValue1", val1 || ""); // First td
                                handleInputChange(3, "inputValue2", val2 || ""); // First td
                              }}
                              style={{
                                width: "110px",
                                borderColor: "black",
                                borderWidth: "1px",
                                borderStyle: "solid",
                              }}
                            />
                          </div>
                        ) : (
                          <>
                            <div
                              className="input-container"
                              onDoubleClick={() => handleDoubleClick("merge4")}
                            >
                              <input
                                type="number"
                                className="form-control d-inline-block ms-2 mb-2 text-center input-required"
                                value={inputValues[3].inputValue1} // First td input
                                readOnly={!isEditable1}
                                onBlur={handleBlur}
                                onChange={
                                  (event) =>
                                    handleInputChange(
                                      3,
                                      "inputValue1",
                                      event.target.value
                                    ) // First td
                                }
                                style={{
                                  cursor: isEditable1 ? "text" : "pointer",
                                  width: "55px",
                                  borderColor: "red",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                disabled={isPlaying.button5}
                              />
                              <span className="tooltip">Required</span>
                            </div>
                            <div
                              className="input-container"
                            // onDoubleClick={() => handleDoubleClick("merge4")}
                            >
                              <input
                                type="number"
                                className="form-control d-inline-block ms-2 mb-2 text-center input-achieved"
                                value={inputValues[3].inputValue2} // First td input
                                readOnly={!isEditable2}
                                onBlur={handleBlur}
                                onChange={
                                  (event) =>
                                    handleInputChange(
                                      3,
                                      "inputValue2",
                                      event.target.value
                                    ) // First td
                                }
                                style={{
                                  cursor: isEditable2 ? "text" : "pointer",
                                  width: "55px",
                                  borderColor: "green",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                disabled={isPlaying.button5}
                              />
                              <span className="tooltip">Achieved</span>
                            </div>
                            <button
                              className="btn p-0 d-flex align-items-center justify-content-center ms-1"
                              style={{
                                width: "2rem",
                                height: "2rem",
                                borderRadius: "50%",
                                backgroundColor: "white",
                              }}
                              onClick={() => handleClick("button5")}
                            >
                              {/* Conditionally render icons based on state */}
                              {isPlaying.button5 ? (
                                <i
                                  className="bi bi-pause-circle-fill"
                                  style={{
                                    fontSize: "1.3rem",
                                    color: "black",
                                  }}
                                ></i>
                              ) : (
                                <i
                                  className="bi bi-play-circle-fill"
                                  style={{
                                    fontSize: "1.3rem",
                                    color: "black",
                                  }}
                                ></i>
                              )}
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                    <td
                      className="py-6 align-bottom last-th"
                      style={{ borderTop: "2px solid white" }}
                    >
                      <div class="d-flex align-items-center mb-2">
                        <div
                          className="input-container"
                          style={{ display: "inline-block" }}
                        >
                          <input
                            type="number"
                            className="form-control d-inline-block mb-2 ms-3 text-center input-required"
                            style={{
                              width: "50px",
                              borderColor: "red",
                              borderWidth: "1px",
                              borderStyle: "solid",
                            }}
                            readOnly
                          />
                        </div>
                        <div class="input-container">
                          <input
                            type="number"
                            class="form-control d-inline-block ms-2 mb-2 text-center input-achieved "
                            style={{
                              width: "55px",
                              borderColor: "green",
                              borderWidth: "1px",
                              borderStyle: "solid",
                            }}
                            readOnly
                          />
                          <span class="tooltip">Achieved</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td rowSpan="2" className="align-middle">
                      <abbr title=" 501 to 1000 employees or 1001 to 2000 employees">
                        501 to 1000 employees{" "}
                        <span style={{ color: "#6495ED", fontWeight: "bold" }}>
                          or
                        </span>{" "}
                        1001 to 2000 employees
                      </abbr>
                    </td>
                    {/* <td>
                      Ceo/Managing Director{" "}
                      <span style={{ color: "#6495ED", fontWeight: "bold" }}>
                        or
                      </span>{" "}
                      Director
                    </td> */}
                    <td>
                      <abbr title="Ceo/Managing Director or Director">
                        Ceo/Managing Director{" "}
                        <span style={{ color: "#6495ED", fontWeight: "bold" }}>
                          or
                        </span>{" "}
                        Director
                      </abbr>
                    </td>
                    <td
                      className="py-6 align-bottom"
                      style={{ borderTop: "2px solid white" }}
                    >
                      <div class="d-flex align-items-center">
                        <div class="input-container">
                          <input
                            type="number"
                            class="form-control d-inline-block mb-2 ms-3 text-center input-achieved"
                            style={{
                              width: "55px",
                              borderColor: "green",
                              borderWidth: "1px",
                              borderStyle: "solid",
                            }}
                          />
                          <span class="tooltip">Achieved</span>
                        </div>
                        <div class="input-container">
                          <input
                            type="number"
                            class="form-control d-inline-block ms-2 mb-2 text-center input-achieved"
                            style={{
                              width: "55px",
                              borderColor: "green",
                              borderWidth: "1px",
                              borderStyle: "solid",
                            }}
                          />
                          <span class="tooltip">Achieved</span>
                        </div>
                        {/* <i
                          class="bi bi-check-circle ms-2"
                          style={{
                            fontSize: "1.5rem",
                            backgroundColor: "green",
                            color: "white",
                            borderRadius: "50%",
                            padding: "0.01rem",
                          }}
                        ></i> */}
                        {/* <button
                          className="btn btn-success p-0 d-flex align-items-center justify-content-center ms-1 mb-4 mt-3"
                          style={{
                            width: "1.5rem",
                            height: "1.5rem",
                            borderRadius: "50%",
                            backgroundColor: "white",
                          }}
                        >
                          <i
                            className="bi bi-check-circle "
                            style={{
                              fontSize: "1.3rem",
                              color: "white",
                            }}
                          ></i>
                        </button> */}
                        <button
                          className="tick ms-2 "
                        // style={{
                        //   background: "none", // Remove background
                        //   border: "none", // Remove border
                        //   padding: "0", // Remove padding
                        //   cursor: "pointer", // Change cursor to pointer
                        // }}
                        >
                          <i class="bi bi-check-circle-fill "></i>
                        </button>
                      </div>
                    </td>

                    <td
                      className="py-6 align-bottom"
                      rowSpan="1"
                      style={{ borderTop: "2px solid white" }}
                    >
                      <div className="d-flex align-items-center">
                        {isMerged.merge5 ? (
                          <div
                            className="input-container merged"
                            onDoubleClick={() => handleDoubleClick("merge5")}
                          >
                            <input
                              type="number"
                              className="form-control text-center input-merged ms-4"
                              value={inputValues[4].inputValue1} // First td input
                              onBlur={handleBlur}
                              onChange={(event) => {
                                const [val1, val2] =
                                  event.target.value.split(" ");
                                handleInputChange(4, "inputValue1", val1 || ""); // First td
                                handleInputChange(4, "inputValue2", val2 || ""); // First td
                              }}
                              style={{
                                width: "110px",
                                borderColor: "black",
                                borderWidth: "1px",
                                borderStyle: "solid",
                              }}
                            />
                          </div>
                        ) : (
                          <>
                            <div
                              className="input-container"
                              onDoubleClick={() => handleDoubleClick("merge5")}
                            >
                              <input
                                type="number"
                                className="form-control d-inline-block ms-2 mb-2 text-center input-required"
                                value={inputValues[4].inputValue1} // First td input
                                readOnly={!isEditable1}
                                onBlur={handleBlur}
                                onChange={
                                  (event) =>
                                    handleInputChange(
                                      4,
                                      "inputValue1",
                                      event.target.value
                                    ) // First td
                                }
                                style={{
                                  cursor: isEditable1 ? "text" : "pointer",
                                  width: "55px",
                                  borderColor: "red",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                disabled={isPlaying.button4}
                              />

                              <span className="tooltip">Required</span>
                            </div>
                            <div
                              className="input-container"
                            // onDoubleClick={() => handleDoubleClick("merge5")}
                            >
                              <input
                                type="number"
                                className="form-control d-inline-block ms-2 mb-2 text-center input-achieved"
                                value={inputValues[4].inputValue2} // First td input
                                readOnly={!isEditable2}
                                onBlur={handleBlur}
                                onChange={
                                  (event) =>
                                    handleInputChange(
                                      4,
                                      "inputValue2",
                                      event.target.value
                                    ) // First td
                                }
                                style={{
                                  cursor: isEditable2 ? "text" : "pointer",
                                  width: "55px",
                                  borderColor: "green",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                disabled={isPlaying.button4}
                              />
                              <span className="tooltip">Achieved</span>
                            </div>
                            <button
                              className="btn p-0 d-flex align-items-center justify-content-center ms-1"
                              style={{
                                width: "2rem",
                                height: "2rem",
                                borderRadius: "50%",
                                backgroundColor: "white",
                              }}
                              onClick={() => handleClick("button4")}
                            >
                              {/* Conditionally render icons based on state */}
                              {isPlaying.button4 ? (
                                <i
                                  className="bi bi-pause-circle-fill"
                                  style={{
                                    fontSize: "1.3rem",
                                    color: "black",
                                  }}
                                ></i>
                              ) : (
                                <i
                                  className="bi bi-play-circle-fill"
                                  style={{
                                    fontSize: "1.3rem",
                                    color: "black",
                                  }}
                                ></i>
                              )}
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                    <td
                      className="py-6 align-bottom"
                      rowSpan="1"
                      style={{ borderTop: "2px solid white" }}
                    >
                      <div className="d-flex align-items-center">
                        {isMerged.merge6 ? (
                          <div
                            className="input-container merged"
                            onDoubleClick={() => handleDoubleClick("merge6")}
                          >
                            <input
                              type="number"
                              className="form-control text-center input-merged ms-4"
                              value={inputValues[5].inputValue1} // First td input
                              onBlur={handleBlur}
                              onChange={(event) => {
                                const [val1, val2] =
                                  event.target.value.split(" ");
                                handleInputChange(5, "inputValue1", val1 || ""); // First td
                                handleInputChange(5, "inputValue2", val2 || ""); // First td
                              }}
                              style={{
                                width: "110px",
                                borderColor: "black",
                                borderWidth: "1px",
                                borderStyle: "solid",
                              }}
                            />
                          </div>
                        ) : (
                          <>
                            <div
                              className="input-container"
                              onDoubleClick={() => handleDoubleClick("merge6")}
                            >
                              <input
                                type="number"
                                className="form-control d-inline-block ms-2 mb-2 text-center input-required"
                                value={inputValues[5].inputValue1} // First td input
                                readOnly={!isEditable1}
                                onBlur={handleBlur}
                                onChange={
                                  (event) =>
                                    handleInputChange(
                                      5,
                                      "inputValue1",
                                      event.target.value
                                    ) // First td
                                }
                                style={{
                                  cursor: isEditable1 ? "text" : "pointer",
                                  width: "55px",
                                  borderColor: "red",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                disabled={isPlaying.button3}
                              />
                              <span className="tooltip">Required</span>
                            </div>
                            <div
                              className="input-container"
                            // onDoubleClick={() => handleDoubleClick("merge6")}
                            >
                              <input
                                type="number"
                                className="form-control d-inline-block ms-2 mb-2 text-center input-achieved"
                                value={inputValues[5].inputValue2} // First td input
                                readOnly={!isEditable2}
                                onBlur={handleBlur}
                                onChange={
                                  (event) =>
                                    handleInputChange(
                                      4,
                                      "inputValue2",
                                      event.target.value
                                    ) // First td
                                }
                                style={{
                                  cursor: isEditable2 ? "text" : "pointer",
                                  width: "55px",
                                  borderColor: "green",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                disabled={isPlaying.button3}
                              />
                              <span className="tooltip">Achieved</span>
                            </div>
                            <button
                              className="btn p-0 d-flex align-items-center justify-content-center ms-1"
                              style={{
                                width: "2rem",
                                height: "2rem",
                                borderRadius: "50%",
                                backgroundColor: "white",
                              }}
                              onClick={() => handleClick("button3")}
                            >
                              {/* Conditionally render icons based on state */}
                              {isPlaying.button3 ? (
                                <i
                                  className="bi bi-pause-circle-fill"
                                  style={{
                                    fontSize: "1.3rem",
                                    color: "black",
                                  }}
                                ></i>
                              ) : (
                                <i
                                  className="bi bi-play-circle-fill"
                                  style={{
                                    fontSize: "1.3rem",
                                    color: "black",
                                  }}
                                ></i>
                              )}
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                    <td
                      className="py-6 align-bottom last-th"
                      rowSpan="1"
                      style={{ borderTop: "2px solid white" }}
                    >
                      <div
                        className="input-container"
                        style={{ display: "inline-block" }}
                      >
                        <input
                          type="number"
                          className="form-control d-inline-block mb-2 ms-3 text-center input-required"
                          style={{
                            width: "50px",
                            borderColor: "red",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                          readOnly
                        />
                        <span className="tooltip">Required</span>
                      </div>
                      <div
                        className="input-container"
                        style={{ display: "inline-block" }}
                      >
                        <input
                          type="number"
                          className="form-control d-inline-block ms-2 text-center input-achieved"
                          style={{
                            width: "54px",
                            borderColor: "green",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                          readOnly
                        />
                        <span className="tooltip">Achieved</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    {/* <td>
                      Ceo/Managing Director{" "}
                      <span style={{ color: "#6495ED", fontWeight: "bold" }}>
                        or
                      </span>{" "}
                      Director
                    </td> */}
                    <td>
                      <abbr title="Ceo/Managing Director or Director">
                        Ceo/Managing Director{" "}
                        <span style={{ color: "#6495ED", fontWeight: "bold" }}>
                          or
                        </span>{" "}
                        Director
                      </abbr>
                    </td>
                    <td
                      className="py-6 align-bottom"
                      style={{ borderTop: "2px solid white" }}
                    >
                      <div class="d-flex align-items-center">
                        <div class="input-container">
                          <input
                            type="number"
                            class="form-control d-inline-block mb-2 ms-3 text-center input-achieved"
                            style={{
                              width: "55px",
                              borderColor: "green",
                              borderWidth: "1px",
                              borderStyle: "solid",
                            }}
                          />
                          <span class="tooltip">Achieved</span>
                        </div>
                        <div class="input-container">
                          <input
                            type="number"
                            class="form-control d-inline-block ms-2 mb-2 text-center input-achieved"
                            style={{
                              width: "55px",
                              borderColor: "green",
                              borderWidth: "1px",
                              borderStyle: "solid",
                            }}
                          />
                          <span class="tooltip">Achieved</span>
                        </div>
                        {/* <i
                          class="bi bi-check-circle ms-2"
                          style={{
                            fontSize: "1.5rem",
                            backgroundColor: "green",
                            color: "white",
                            borderRadius: "50%",
                            padding: "0.01rem",
                          }}
                        ></i> */}
                        {/* <button
                          className="btn btn-success p-0 d-flex align-items-center justify-content-center ms-1 mb-2"
                          style={{
                            width: "1.5rem",
                            height: "1.5rem",
                            borderRadius: "50%",
                            backgroundColor: "white",
                          }}
                        >
                          <i
                            className="bi bi-check-circle "
                            style={{
                              fontSize: "1.3rem",
                              color: "white",
                            }}
                          ></i>
                        </button> */}
                        <button
                          className="tick ms-2 "
                        // style={{
                        //   background: "none", // Remove background
                        //   border: "none", // Remove border
                        //   padding: "0", // Remove padding
                        //   cursor: "pointer", // Change cursor to pointer
                        // }}
                        >
                          <i class="bi bi-check-circle-fill "></i>
                        </button>
                      </div>
                    </td>

                    <td
                      className="py-6 align-bottom"
                      rowSpan="1"
                      style={{ borderTop: "2px solid white" }}
                    >
                      <div className="d-flex align-items-center">
                        {isMerged.merge7 ? (
                          <div
                            className="input-container merged"
                            onDoubleClick={() => handleDoubleClick("merge7")}
                          >
                            <input
                              type="number"
                              className="form-control text-center input-merged ms-4"
                              value={inputValues[6].inputValue1} // First td input
                              onBlur={handleBlur}
                              onChange={(event) => {
                                const [val1, val2] =
                                  event.target.value.split(" ");
                                handleInputChange(6, "inputValue1", val1 || ""); // First td
                                handleInputChange(6, "inputValue2", val2 || ""); // First td
                              }}
                              style={{
                                width: "110px",
                                borderColor: "black",
                                borderWidth: "1px",
                                borderStyle: "solid",
                              }}
                            />
                          </div>
                        ) : (
                          <>
                            <div
                              className="input-container"
                              onDoubleClick={() => handleDoubleClick("merge7")}
                            >
                              <input
                                type="number"
                                className="form-control d-inline-block ms-2 mb-2 text-center input-required"
                                value={inputValues[6].inputValue1} // First td input
                                readOnly={!isEditable1}
                                onBlur={handleBlur}
                                onChange={
                                  (event) =>
                                    handleInputChange(
                                      5,
                                      "inputValue1",
                                      event.target.value
                                    ) // First td
                                }
                                style={{
                                  cursor: isEditable1 ? "text" : "pointer",
                                  width: "55px",
                                  borderColor: "red",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                disabled={isPlaying.button2}
                              />
                              <span className="tooltip">Required</span>
                            </div>
                            <div
                              className="input-container"
                            // onDoubleClick={() => handleDoubleClick("merge7")}
                            >
                              <input
                                type="number"
                                className="form-control d-inline-block ms-2 mb-2 text-center input-achieved"
                                value={inputValues[6].inputValue2} // First td input
                                readOnly={!isEditable2}
                                onBlur={handleBlur}
                                onChange={
                                  (event) =>
                                    handleInputChange(
                                      6,
                                      "inputValue2",
                                      event.target.value
                                    ) // First td
                                }
                                style={{
                                  cursor: isEditable2 ? "text" : "pointer",
                                  width: "55px",
                                  borderColor: "green",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                disabled={isPlaying.button2}
                              />
                              <span className="tooltip">Achieved</span>
                            </div>
                            <button
                              className="btn p-0 d-flex align-items-center justify-content-center ms-1"
                              style={{
                                width: "2rem",
                                height: "2rem",
                                borderRadius: "50%",
                                backgroundColor: "white",
                              }}
                              onClick={() => handleClick("button2")}
                            >
                              {/* Conditionally render icons based on state */}
                              {isPlaying.button2 ? (
                                <i
                                  className="bi bi-pause-circle-fill"
                                  style={{
                                    fontSize: "1.3rem",
                                    color: "black",
                                  }}
                                ></i>
                              ) : (
                                <i
                                  className="bi bi-play-circle-fill"
                                  style={{
                                    fontSize: "1.3rem",
                                    color: "black",
                                  }}
                                ></i>
                              )}
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                    <td
                      className="py-6 align-bottom"
                      rowSpan="1"
                      style={{ borderTop: "2px solid white" }}
                    >
                      <div className="d-flex align-items-center">
                        {isMerged.merge8 ? (
                          <div
                            className="input-container merged"
                            onDoubleClick={() => handleDoubleClick("merge8")}
                          >
                            <input
                              type="number"
                              className="form-control text-center input-merged ms-4"
                              value={inputValues[7].inputValue1} // First td input
                              onBlur={handleBlur}
                              onChange={(event) => {
                                const [val1, val2] =
                                  event.target.value.split(" ");
                                handleInputChange(7, "inputValue1", val1 || ""); // First td
                                handleInputChange(7, "inputValue2", val2 || ""); // First td
                              }}
                              style={{
                                width: "110px",
                                borderColor: "black",
                                borderWidth: "1px",
                                borderStyle: "solid",
                              }}
                            />
                          </div>
                        ) : (
                          <>
                            <div
                              className="input-container"
                              onDoubleClick={() => handleDoubleClick("merge8")}
                            >
                              <input
                                type="number"
                                className="form-control d-inline-block ms-2 mb-2 text-center input-required"
                                value={inputValues[7].inputValue1} // First td input
                                readOnly={!isEditable1}
                                onBlur={handleBlur}
                                onChange={
                                  (event) =>
                                    handleInputChange(
                                      7,
                                      "inputValue1",
                                      event.target.value
                                    ) // First td
                                }
                                style={{
                                  cursor: isEditable1 ? "text" : "pointer",
                                  width: "55px",
                                  borderColor: "red",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                disabled={isPlaying.button1}
                              />
                              <span className="tooltip">Required</span>
                            </div>
                            <div
                              className="input-container"
                            // onDoubleClick={() => handleDoubleClick("merge8")}
                            >
                              <input
                                type="number"
                                className="form-control d-inline-block ms-2 mb-2 text-center input-achieved"
                                value={inputValues[7].inputValue2} // First td input
                                readOnly={!isEditable2}
                                onBlur={handleBlur}
                                onChange={
                                  (event) =>
                                    handleInputChange(
                                      6,
                                      "inputValue2",
                                      event.target.value
                                    ) // First td
                                }
                                style={{
                                  cursor: isEditable2 ? "text" : "pointer",
                                  width: "55px",
                                  borderColor: "green",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                disabled={isPlaying.button1}
                              />
                              <span className="tooltip">Achieved</span>
                            </div>
                            <button
                              className="btn p-0 d-flex align-items-center justify-content-center ms-1"
                              style={{
                                width: "2rem",
                                height: "2rem",
                                borderRadius: "50%",
                                backgroundColor: "white",
                              }}
                              onClick={() => handleClick("button1")}
                            >
                              {/* Conditionally render icons based on state */}
                              {isPlaying.button1 ? (
                                <i
                                  className="bi bi-pause-circle-fill"
                                  style={{
                                    fontSize: "1.3rem",
                                    color: "black",
                                  }}
                                ></i>
                              ) : (
                                <i
                                  className="bi bi-play-circle-fill"
                                  style={{
                                    fontSize: "1.3rem",
                                    color: "black",
                                  }}
                                ></i>
                              )}
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                    <td
                      className="py-6 align-bottom last-th"
                      rowSpan="1"
                      style={{ borderTop: "2px solid white" }}
                    >
                      <div
                        className="input-container"
                        style={{ display: "inline-block" }}
                      >
                        <input
                          type="number"
                          className="form-control d-inline-block mb-2 ms-3 text-center input-required"
                          style={{
                            width: "50px",
                            borderColor: "red",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                          readOnly
                        />
                        <span className="tooltip">Required</span>
                      </div>
                      <div
                        className="input-container"
                        style={{ display: "inline-block" }}
                      >
                        <input
                          type="number"
                          className="form-control d-inline-block ms-2 text-center input-achieved"
                          style={{
                            width: "54px",
                            borderColor: "green",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                          readOnly
                        />
                        <span className="tooltip">Achieved</span>
                      </div>
                    </td>
                  </tr>
                  <tr class="table-light last-th up">
                    <td
                      colSpan="7"
                      className=" py-1 align-bottom text-end fw-semibold first-th pe-5 text-muted"
                      style={{
                        borderTop: "2px solid white",
                        borderRight: "2px solid white",
                        borderLeft: "2px solid white",
                        borderBottom: "2px solid white",
                      }}
                    >
                      Grand Total
                      {/* </td>
                    <td className="py-1 align-bottom"> */}
                      <div
                        className="input-container"
                        style={{ display: "inline-block" }}
                      >
                        <input
                          type="number"
                          className="form-control d-inline-block ms-3 text-center input-required"
                          style={{
                            width: "55px",
                            borderColor: "red",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                          readOnly
                        />
                        <span className="tooltip">Required</span>
                      </div>
                      <div
                        className="input-container"
                        style={{ display: "inline-block" }}
                      >
                        <input
                          type="number"
                          className="form-control d-inline-block ms-1 text-center input-achieved"
                          style={{
                            width: "55px",
                            borderColor: "green",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                          readOnly
                        />
                        <span className="tooltip">Achieved</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotaView;
//commit
//update
